import React from 'react'
import styled from 'styled-components'

type Props = {
  children: React.ReactNode
}

export const Title: React.FC<Props> = props => (
  <StyledTitle>{props.children}</StyledTitle>
)

const StyledTitle = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0.28px;
  word-wrap: break-word;
`
